import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { getGameById } from "@/lib/gamesConfig";

const GameDetailsPage = () => {
  const { gameId } = useParams();
  const { t } = useTranslation();
  const game = getGameById(gameId);

  if (!game) {
    return (
      <div className="game-details-page">
        <p className="game-details-title">{t("common.error")}</p>
        <p className="game-details-subtitle">Игра не найдена</p>
      </div>
    );
  }

  return (
    <div className="game-details-page" data-testid={`game-page-${game.id}`}>
      <img src={game.image} alt={game.title} className="game-details-preview" />
      <p className="game-details-title">{game.title}</p>
      <p className="game-details-subtitle">
        Здесь будет отдельная страница игры.
      </p>
    </div>
  );
};

export default GameDetailsPage;
